import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

export const createReservation = (data) => http.post("/reservations", data).then((r) => r.data);
export const sendContactMessage = (data) => http.post("/contact", data).then((r) => r.data);

export const getContent = () => http.get("/content").then((r) => r.data);
export const updateContent = (data) => http.put("/content", data).then((r) => r.data);

export const getMe = () => http.get("/auth/me").then((r) => r.data);
export const postSession = (sessionId) =>
  http.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);
export const logout = () => http.post("/auth/logout").then((r) => r.data);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return http
    .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => ({ ...r.data, absoluteUrl: `${BACKEND_URL}${r.data.url}` }));
};

export const LIVE_FRAME_URL = `${API}/live/frame`;
export const getLiveStatus = () => http.get("/live/status").then((r) => r.data);
export const uploadLiveFrame = (blob) => {
  const fd = new FormData();
  fd.append("file", blob, "frame.jpg");
  return http.post("/live/frame", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// ---- Careers ----
export const getJobs = () => http.get("/jobs").then((r) => r.data);
export const getAllJobs = () => http.get("/jobs/all").then((r) => r.data);
export const createJob = (data) => http.post("/jobs", data).then((r) => r.data);
export const updateJob = (id, data) => http.put(`/jobs/${id}`, data).then((r) => r.data);
export const deleteJob = (id) => http.delete(`/jobs/${id}`).then((r) => r.data);

export const submitApplication = (formData) =>
  http.post("/applications", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const getApplications = (params = {}) => http.get("/applications", { params }).then((r) => r.data);
export const updateApplication = (id, data) => http.patch(`/applications/${id}`, data).then((r) => r.data);
export const deleteApplication = (id) => http.delete(`/applications/${id}`).then((r) => r.data);
export const exportApplications = (format, params = {}) =>
  http.get("/applications/export", { params: { format, ...params }, responseType: "blob" }).then((r) => r.data);

// ---- Catering ----
export const getCateringPackages = () => http.get("/catering/packages").then((r) => r.data);
export const getAllCateringPackages = () => http.get("/catering/packages/all").then((r) => r.data);
export const createCateringPackage = (data) => http.post("/catering/packages", data).then((r) => r.data);
export const updateCateringPackage = (id, data) => http.put(`/catering/packages/${id}`, data).then((r) => r.data);
export const deleteCateringPackage = (id) => http.delete(`/catering/packages/${id}`).then((r) => r.data);

export const submitCateringRequest = (formData) =>
  http.post("/catering/requests", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const getCateringRequests = (params = {}) => http.get("/catering/requests", { params }).then((r) => r.data);
export const updateCateringRequest = (id, data) => http.patch(`/catering/requests/${id}`, data).then((r) => r.data);
export const deleteCateringRequest = (id) => http.delete(`/catering/requests/${id}`).then((r) => r.data);
export const exportCateringRequests = (format, params = {}) =>
  http.get("/catering/requests/export", { params: { format, ...params }, responseType: "blob" }).then((r) => r.data);
export const downloadCateringDoc = (id, kind) =>
  http.get(`/catering/requests/${id}/${kind}.pdf`, { responseType: "blob" }).then((r) => r.data);
export const downloadCateringDayPlan = (date) =>
  http.get(`/catering/plan.pdf`, { responseType: "blob", params: { date } }).then((r) => r.data);
